import { MessageCircle } from "lucide-react";

const DEFAULT_TEMPLATE = `Hello Doctor,

I would like to book an appointment.

Name:
Phone:
Preferred Date:
Preferred Time:
Treatment:`;

export function buildWhatsAppLink(number, template = DEFAULT_TEMPLATE) {
  const clean = String(number || "").replace(/[^0-9]/g, "");
  const encoded = encodeURIComponent(template);
  return `https://wa.me/${clean}?text=${encoded}`;
}

export default function WhatsAppFloating({ number, testId = "btn-whatsapp-float" }) {
  if (!number) return null;
  return (
    <a
      href={buildWhatsAppLink(number)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      aria-label="Chat with us on WhatsApp"
      className="fixed z-40 bottom-5 right-5 sm:bottom-6 sm:right-6 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-70 blur-lg animate-pulse" aria-hidden />
      <span className="relative flex items-center gap-3 bg-[#25D366] hover:bg-[#1FBA5A] text-white rounded-full pl-3 pr-5 py-3 soft-shadow-lg transition-colors">
        <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
          <MessageCircle className="w-5 h-5" strokeWidth={2} fill="currentColor" />
        </span>
        <span className="hidden sm:inline text-sm font-medium">Chat with us</span>
      </span>
    </a>
  );
}

/**
 * A pre-styled WhatsApp booking button, matches the primary CTA look.
 */
export function WhatsAppButton({ number, testId = "btn-whatsapp-book", label = "Book on WhatsApp", className = "" }) {
  return (
    <a
      href={buildWhatsAppLink(number)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      className={`inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1FBA5A] text-white h-12 px-6 font-medium transition-colors ${className}`}
    >
      <MessageCircle className="w-5 h-5" strokeWidth={2} />
      {label}
    </a>
  );
}
